import type { FormHiddenFieldStoryblok } from '@utils/storyblok/storyblok';

type HiddenInputProps = FormHiddenFieldStoryblok & {
  value: string | boolean | number | null | undefined;
};

export function createHiddenInput({ name, value, ...props }: HiddenInputProps) {
  return {
    ...props,
    _uid: `hidden-${name}`,
    component: 'FormHiddenField',
    name,
    value: String(value),
  };
}
